
import OnlineCareRequestWithoutTypeVue from "@/components/onlineCare/OnlineCareRequestWithoutType";
import OnlineCareRequestWithTypeVue from "@/components/onlineCare/OnlineCareRequestWithType";
import { defineComponent, onMounted, reactive, ref } from "vue";
import PageFrame from "@/components/common/PageFrame.vue";
import SelectedHospital from "@/components/common/SelectedHospital.vue";

export default defineComponent({
  props: {
    hcode: String,
    dcode: String,
  },

  setup(props) {
    console.log("props=>", props);

    // type : quick | normal
    const isType = ref(process.env.VUE_APP_IS_QUICK === "true");
    const onlineCareRequest = isType.value
      ? OnlineCareRequestWithTypeVue
      : OnlineCareRequestWithoutTypeVue;

    const state = reactive({
      selectHospital: null as null | Number,
      isLoading: true,
    });

    onMounted(() => {
      state.selectHospital = process.env.VUE_APP_IS_SELECTHOSPITAL === "true" ? null : 0;
      console.log(state.selectHospital, "state.selectHospital");

      state.isLoading = false;
    });

    return { isType, onlineCareRequest, state };
  },
  components: {
    PageFrame,
    SelectedHospital,
  },
});
